import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Meta Descriptions
      meta: {
        home: "Tensor Engineering Services LLC - Your trusted engineering partner in Dubai, UAE. Specialized in mechanical, electrical, and control valve services for industrial solutions.",
        about: "Leading engineering service provider in Dubai with expertise in pipeline services, equipment procurement, and industrial solutions.",
        services: "Comprehensive engineering services including mechanical, electrical, control valve maintenance, and specialized industrial solutions in Dubai.",
        contact: "Connect with Tensor Engineering Services LLC for expert engineering solutions in Dubai. Get in touch for mechanical, electrical, and control valve services.",
        blog: "Stay updated with the latest engineering insights, industry trends, and technical expertise from TensorME's engineering professionals."
      },
      
      // General
      logoAlt: "TensorME Logo",
      
      // Navigation
      home: 'Home',
      about: 'About',
      services: 'Services',
      contact: 'Contact',
      
      // Services Names
      pipelineServices: 'Pipeline Services',
      cleaningServices: 'Specialised Cleaning Services',
      hydraulicServices: 'Hydraulic Engineering Services',
      electricalServices: 'Electrical & Instrumentation Services',
      valveServices: 'Control Valves & Actuator Services',
      
      // Hero Section
      heroTitle: 'Engineering Excellence in Dubai',
      heroSubtitle: 'Your Trusted Partner in Industrial Solutions',
      heroDescription: 'Delivering comprehensive engineering solutions with unmatched expertise and reliability',
      heroSlideAlt: 'slide ',
      
      // Hero Slides
      heroSlide1Title: 'Specialized Engineering Solutions',
      heroSlide1Desc: 'Tailored solutions for industrial, marine, and oil & gas sectors, optimizing operational efficiency and ensuring regulatory compliance.',
      heroSlide2Title: 'Equipment Procurement Expertise',
      heroSlide2Desc: 'Specialized sourcing, customization, and support for top-quality oil & gas, marine, and testing equipment.',
      heroSlide3Title: 'Rental Services',
      heroSlide3Desc: 'High-pressure testing, hydraulic power packs, torque wrenches, hot oil flushing, and more for industrial needs.',
      
      // About Section
      aboutTitle: 'About TensorME',
      aboutDesc: 'Leading provider of specialized engineering services in Dubai, delivering excellence in mechanical, electrical, and control systems.',
      aboutContent: 'With years of experience in the industry, we provide cutting-edge engineering solutions tailored to meet your specific needs. Our team of experts ensures the highest quality standards in every project.',
      
      // Services Descriptions
      pipelineDesc: 'Comprehensive pipeline services including testing, maintenance, and repair solutions for industrial applications.',
      cleaningDesc: 'Advanced cleaning solutions for industrial equipment and systems using state-of-the-art technology.',
      hydraulicDesc: 'Expert hydraulic engineering services for design, installation, and maintenance of hydraulic systems.',
      electricalDesc: 'Complete electrical and instrumentation services for industrial automation and control systems.',
      valveDesc: 'Specialized services for control valves and actuators including maintenance, repair, and optimization.',
      
      // Contact Form
      contactTitle: 'Get in Touch',
      contactSubtitle: 'Expert Engineering Solutions',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      message: 'Message',
      send: 'Send Message',
      enquiryOn: 'Enquiry on',
      
      // Footer
      address: 'Dubai, UAE',
      phone: '+971-XXX-XXXX',
      email: 'info@tensorme.com',
      copyright: '© 2024 Tensor Engineering Services LLC. All rights reserved.\nA Tensorloop Pty Ltd, Australia Ventured Company',
      goToTop: 'Go to top',

      // Pipeline Services Modal
      pipelineModalDesc: 'We provide a comprehensive maintenance plan designed to extend the longevity of your critical systems and equipment. Our flush plans encompass a thorough assessment of reservoirs, screens, heat exchangers, coolers, turbines, and all related system components. Our services include comprehensive solutions for contaminant removal, moisture level adjustment, varnish elimination, and meticulous degreasing and pickling of equipment.',
      pipelineService1: 'Pre commissioning activities',
      pipelineService2: 'Hydro testing services',
      pipelineService3: 'De-contamination services',
      pipelineService4: 'Helium leak testing',
      pipelineService5: 'High pressure testing',
      getQuote: 'Get quote',

      // Hydraulic Services Modal
      hydraulicModalTitle: 'Hydraulic Engineering Services',
      hydraulicModalDesc: 'Ensure the peak performance and longevity of your hydraulic equipment with our comprehensive servicing and maintenance solutions. Our expert team delivers meticulous on-site maintenance to guarantee uninterrupted functionality and optimal condition for all types of hydraulic equipment.',
      hydraulicService1: 'Hydraulic equipment installation and testing',
      hydraulicService2: 'Hot oil flushing',
      hydraulicService3: 'Hydraulic system trouble shooting & repairs',
      hydraulicService4: 'Hydraulic oil condition monitoring',

      // Valves Services Modal
      valveModalTitle: 'Control Valves & Actuator Services',
      valveModalDesc: 'Drawing on extensive expertise in valve actuation, our highly experienced team at Tensor delivers efficient, timely, and comprehensive shop and field services. Covering the entire spectrum from installation to maintenance and repair, our offerings provide a complete suite of services aimed at maximizing the value derived from your valves. With cradle-to-grave support, we ensure the longevity and optimal performance of all your valves.',
      valveService1: 'Pre commissioning activities',
      valveService2: 'Hydro testing services',
      valveService3: 'De-contamination services',
      valveService4: 'Helium leak testing',
      valveService5: 'High pressure testing',

      // Cleaning Services Modal
      cleaningModalTitle: 'Specialised Cleaning Services',
      cleaningModalSuffix: '(Pipes/Tubes/Pressure Vessels)',
      cleaningModalDesc: 'Experience unparalleled cleanliness and efficiency with our specialized cleaning services tailored for pipes, tubes, and pressure vessels. From meticulous chemical cleaning to high-pressure water jetting and precise pickling and passivation techniques, we ensure optimal performance and longevity for your critical equipment.',
      cleaningService1: 'Chemical cleaning',
      cleaningService2: 'High pressure water jetting',
      cleaningService3: 'Pickling and passivation',

      // Electrical Services Modal
      electricalModalTitle: 'Electrical & Instrumentation Services',
      electricalModalDesc: 'At Tensor, we specialize in delivering engineering services encompassing Instrumentation, Electrical, and Automation across diverse process domains. Our approach centers on prioritizing customer needs, maintaining exceptional quality standards, ensuring timely project completion, and optimizing costs. Our team of skilled engineers consistently delivers solutions that meet and exceed customer expectations, ensuring prompt and reliable service every time.',
      electricalService1: 'Instrumentation testing services',
      electricalService2: 'Control system trouble shooting',
      electricalService3: 'Onsite support',
      electricalService4: 'Building automation installation',

      // Services Additional
      servicesSubtitle: 'services we provide',
      
      // Contact Additional
      contactSubject: 'Subject',
      contactMailDetails: 'Please find the contact details below',
    }
  },
  ar: {
    translation: {
      // Meta Descriptions
      meta: {
        home: "تينسور إم إي - شريكك الموثوق في الهندسة في دبي، الإمارات. متخصصون في الخدمات الميكانيكية والكهربائية وصمامات التحكم للحلول الصناعية.",
        about: "مزود خدمات هندسية رائد في دبي مع خبرة في خدمات خطوط الأنابيب وتوريد المعدات والحلول الصناعية.",
        services: "خدمات هندسية شاملة تشمل الصيانة الميكانيكية والكهربائية وصمامات التحكم والحلول الصناعية المتخصصة في دبي.",
        contact: "تواصل مع تينسور إم إي للحصول على حلول هندسية متخصصة في دبي.",
        blog: "ابق على اطلاع بأحدث الرؤى الهندسية واتجاهات الصناعة والخبرة التقنية."
      },
      
      // General
      logoAlt: "شعار تينسور إم إي",
      
      // Navigation
      home: 'الرئيسية',
      about: 'عن الشركة',
      services: 'خدماتنا',
      contact: 'اتصل بنا',
      
      // Services Names
      pipelineServices: 'خدمات خطوط الأنابيب',
      cleaningServices: 'خدمات التنظيف المتخصصة',
      hydraulicServices: 'خدمات الهندسة الهيدروليكية',
      electricalServices: 'خدمات الكهرباء والأجهزة',
      valveServices: 'خدمات صمامات التحكم والمشغلات',
      
      // Hero Section
      heroTitle: 'التميز الهندسي في دبي',
      heroSubtitle: 'شريكك الموثوق في الحلول الصناعية',
      heroDescription: 'نقدم حلولاً هندسية شاملة بخبرة وموثوقية لا مثيل لها',
      heroSlideAlt: 'شريحة ',
      
      // Hero Slides
      heroSlide1Title: 'حلول هندسية متخصصة',
      heroSlide1Desc: 'حلول مخصصة للقطاعات الصناعية والبحرية والنفط والغاز، تعمل على تحسين كفاءة التشغيل وضمان الامتثال التنظيمي.',
      heroSlide2Title: 'خبرة في توريد المعدات',
      heroSlide2Desc: 'مصادر متخصصة وتخصيص ودعم لمعدات النفط والغاز والمعدات البحرية ومعدات الاختبار عالية الجودة.',
      heroSlide3Title: 'خدمات التأجير',
      heroSlide3Desc: 'اختبار الضغط العالي، حزم الطاقة الهيدروليكية، مفاتيح العزم، تنظيف الزيت الساخن، والمزيد للاحتياجات الصناعية.',
      
      // About Section
      aboutTitle: 'عن تينسور إم إي',
      aboutDesc: 'مزود رائد للخدمات الهندسية المتخصصة في دبي، نقدم التميز في الأنظمة الميكانيكية والكهربائية والتحكم.',
      aboutContent: 'مع سنوات من الخبرة في الصناعة، نقدم حلولاً هندسية متطورة مصممة لتلبية احتياجاتك الخاصة. يضمن فريق خبرائنا أعلى معايير الجودة في كل مشروع.',
      
      // Services Descriptions
      pipelineDesc: 'خدمات شاملة لخطوط الأنابيب تشمل الاختبار والصيانة وحلول الإصلاح للتطبيقات الصناعية.',
      cleaningDesc: 'حلول تنظيف متقدمة للمعدات والأنظمة الصناعية باستخدام أحدث التقنيات.',
      hydraulicDesc: 'خدمات هندسية هيدروليكية متخصصة لتصميم وتركيب وصيانة الأنظمة الهيدروليكية.',
      electricalDesc: 'خدمات كهربائية وأجهزة متكاملة لأنظمة التحكم والأتمتة الصناعية.',
      valveDesc: 'خدمات متخصصة لصمامات التحكم والمشغلات تشمل الصيانة والإصلاح والتحسين.',
      
      // Contact Form
      contactTitle: 'تواصل معنا',
      contactSubtitle: 'حلول هندسية متخصصة',
      name: 'الاسم',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
      message: 'الرسالة',
      send: 'إرسال الرسالة',
      enquiryOn: 'استفسار عن',
      
      // Footer
      address: 'دبي، الإمارات العربية المتحدة',
      phone: '+971-XXX-XXXX',
      email: 'info@tensorme.com',
      copyright: '© 2024 تينسور إم إي. جميع الحقوق محفوظة.\nشركة تينسورلوب بي تي واي المحدودة، شركة استرالية',
      goToTop: 'العودة إلى الأعلى',

      // Pipeline Services Modal
      pipelineModalDesc: 'نقدم خطة صيانة شاملة مصممة لإطالة عمر أنظمتك ومعداتك الحيوية. تشمل خطط التنظيف لدينا تقييماً شاملاً للخزانات والشاشات والمبادلات الحرارية والمبردات والتوربينات وجميع مكونات النظام ذات الصلة. تشمل خدماتنا حلولاً شاملة لإزالة الملوثات وضبط مستوى الرطوبة وإزالة الورنيش وإزالة الشحوم والتخليل الدقيق للمعدات.',
      pipelineService1: 'أنشطة ما قبل التشغيل',
      pipelineService2: 'خدمات الاختبار الهيدروليكي',
      pipelineService3: 'خدمات إزالة التلوث',
      pipelineService4: 'اختبار تسرب الهيليوم',
      pipelineService5: 'اختبار الضغط العالي',
      getQuote: 'احصل على عرض سعر',

      // Hydraulic Services Modal
      hydraulicModalTitle: 'خدمات الهندسة الهيدروليكية',
      hydraulicModalDesc: 'اضمن الأداء الأمثل وطول عمر معداتك الهيدروليكية مع حلول الصيانة الشاملة التي نقدمها. يقدم فريق الخبراء لدينا صيانة دقيقة في الموقع لضمان الأداء المستمر والحالة المثلى لجميع أنواع المعدات الهيدروليكية.',
      hydraulicService1: 'تركيب واختبار المعدات الهيدروليكية',
      hydraulicService2: 'تنظيف الزيت الساخن',
      hydraulicService3: 'استكشاف أخطاء النظام الهيدروليكي وإصلاحها',
      hydraulicService4: 'مراقبة حالة الزيت الهيدروليكي',

      // Valves Services Modal
      valveModalTitle: 'خدمات صمامات التحكم والمشغلات',
      valveModalDesc: 'اعتماداً على خبرتنا الواسعة في تشغيل الصمامات، يقدم فريقنا ذو الخبرة العالية في تينسور خدمات ورشة وميدانية فعالة وفي الوقت المناسب وشاملة. تغطي خدماتنا الطيف الكامل من التركيب إلى الصيانة والإصلاح، وتوفر مجموعة كاملة من الخدمات تهدف إلى زيادة القيمة المستمدة من صماماتك. مع دعم من المهد إلى اللحد، نضمن طول العمر والأداء الأمثل لجميع صماماتك.',
      valveService1: 'أنشطة ما قبل التكليف',
      valveService2: 'خدمات الاختبار الهيدروليكي',
      valveService3: 'خدمات إزالة التلوث',
      valveService4: 'اختبار تسرب الهيليوم',
      valveService5: 'اختبار الضغط العالي',

      // Cleaning Services Modal
      cleaningModalTitle: 'خدمات التنظيف المتخصصة',
      cleaningModalSuffix: '(الأنابيب/الأنابيب/أوعية الضغط)',
      cleaningModalDesc: 'استمتع بنظافة وكفاءة لا مثيل لها مع خدمات التنظيف المتخصصة المصممة خصيصاً للأنابيب والأنابيب وأوعية الضغط. من التنظيف الكيميائي الدقيق إلى نفث الماء عالي الضغط وتقنيات التخليل والتخميل الدقيقة، نضمن الأداء الأمثل وطول العمر لمعداتك الحيوية.',
      cleaningService1: 'التنظيف الكيميائي',
      cleaningService2: 'نفث الماء عالي الضغط',
      cleaningService3: 'التخليل والتخميل',

      // Electrical Services Modal
      electricalModalTitle: 'خدمات الكهرباء والأجهزة',
      electricalModalDesc: 'في تينسور، نتخصص في تقديم خدمات هندسية تشمل الأجهزة والكهرباء والأتمتة عبر مجالات عملية متنوعة. ينصب نهجنا على إعطاء الأولوية لاحتياجات العملاء، والحفاظ على معايير جودة استثنائية، وضمان إنجاز المشروع في الوقت المحدد، وتحسين التكاليف. يقدم فريق المهندسين المهرة لدينا باستمرار حلولاً تلبي وتتجاوز توقعات العملاء، مما يضمن خدمة سريعة وموثوقة في كل مرة.',
      electricalService1: 'خدمات اختبار الأجهزة',
      electricalService2: 'استكشاف أخطاء نظام التحكم',
      electricalService3: 'الدعم في الموقع',
      electricalService4: 'تركيب أتمتة المباني',

      // Services Additional
      servicesSubtitle: 'الخدمات التي نقدمها',
      
      // Contact Additional
      contactSubject: 'الموضوع',
      contactMailDetails: 'يرجى الاطلاع على تفاصيل الاتصال أدناه',
    }
  }
};

// Initialize i18n with improved configuration
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    
    // Enhanced detection options
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
      checkWhitelist: true
    },
    
    interpolation: {
      escapeValue: false
    },
    
    react: {
      useSuspense: false,
      bindI18n: 'languageChanged'
    }
  });

// Ensure language is properly initialized
const savedLang = localStorage.getItem('i18nextLng');
if (!savedLang) {
  localStorage.setItem('i18nextLng', 'en');
  i18n.changeLanguage('en');
} else {
  i18n.changeLanguage(savedLang);
}

// Set direction based on current language
document.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
document.documentElement.lang = i18n.language;

export default i18n; 